import styled, { css } from 'styled-components';

export const TokenSymbolInput = styled.span<{ dark?: boolean }>`
  position: absolute;
  right: 1rem;
  padding-left: 0.5rem;
  font-weight: 500;

  ${({ dark }) =>
    dark &&
    css`
      color: #fff;
    `}

  &:after {
    position: absolute;
    content: '';
    width: 1px;
    height: 1.75em;
    left: 0;
    top: -25%;
    background: #d2d6e8;

    ${({ dark }) =>
      dark &&
      css`
        background: #35486d;
      `}
  }
`;
